import React from 'react'
import { withRouter } from "react-router-dom"
import axios from 'axios'
import CONS from "../constants"
import Alert from "../functions/alert"
import Valid from "../functions/validation"
import MainLayout from "../components/main-layout"
import ContentEntryUI from "./content-entry-ui"

class ContentEdit extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            attr: {
                access_token: "",
                loading: true,
                disabled: false
            },
            data: {
                id: "",
                title_th: "",
                title_en: "",
                description_th: "",
                description_en: "",
                image: "",
                old_image: "",
                name_image: "",
            },
        }
    }

    handleChange = (e) => {
        this.setState({ data: { ...this.state.data, [e.target.name]: e.target.value } })
    }

    handleChangeEditor = (e) => {
        this.setState({ data: { ...this.state.data, [e.name]: e.value } })
    }

    handleChangeFile = (e) => {
        var data = this.state.data
        if (e.target.files[0] !== undefined) {
            var file = e.target.files[0]
            if (file.size > 5000000) {
                data.name_image = ""
                document.getElementById(e.target.name).value = ""
                Alert.showMsg('ขนาดไฟล์จะต้องมีขนาดไม่เกิน 5 MB', 'danger')
            } else if (!file.type.match(/image\/png|image\/jpg|image\/jpeg|image\/webp/g)) {
                data.name_image = ""
                document.getElementById(e.target.name).value = ""
                Alert.showMsg('รองรับไฟล์นามสกุล .jpg .png เท่านั้น', 'danger')
            } else {
                data.name_image = e.target.files[0].name
            }
        } else {
            data.name_image = ""
        }
        this.setState({ data: data })
    }

    handleSave = () => {
        var valid = Valid.form("submit-form")
        if (this.state.data.description_th === "") Valid.show("description_th")
        if (this.state.data.description_en === "") Valid.show("description_en")
        if (valid && this.state.data.description_th !== "" && this.state.data.description_en !== "") {
            var params = new FormData(document.querySelector('[id="submit-form"]'))
            Alert.loadingScreen("กำลังบันทึกข้อมูล กรุณารอสักครู่.....")
            axios.post(CONS.API_CONTENT + "/update", params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': CONS.AUTH_PREFIX + this.state.attr.access_token
                }
            }
            ).then((response) => {
                Alert.loadingScreen("กำลังบันทึกข้อมูล กรุณารอสักครู่.....")
                if (response.data.status === "success") {
                    localStorage.setItem("alert", "บันทึกสำเร็จ")
                    this.props.history.push(CONS.URL_LINK + `/content`)
                } else {
                    localStorage.removeItem('login_token')
                    this.props.history.push(CONS.URL_LINK + '/login?auth=false')
                }
            }).catch((error) => {
                Alert.loadingScreen("กำลังบันทึกข้อมูล กรุณารอสักครู่.....")
                if (error.response.status === 401) {
                    localStorage.removeItem('login_token')
                    this.props.history.push(CONS.URL_LINK + '/login?auth=false')
                } else {
                    console.log(error)
                }
            })
        }
    }

    loadData = () => {
        axios.post(CONS.API_CONTENT + "/list", {
            id: this.props.match.params.id
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': CONS.AUTH_PREFIX + this.state.attr.access_token
            }
        }
        ).then((response) => {
            if (response.data.status === "success") {
                if (response.data.list.length > 0) {
                    this.setState({ data: response.data.list[0], attr: { ...this.state.attr, loading: false } })
                } else {
                    Alert.showMsg("ไม่พบข้อมูล", "danger")
                    this.setState({attr : {...this.state.attr, loading : false, disabled : true}})
                }
            }
        }).catch((error) => {
            if(error.response.status === 401){
                localStorage.removeItem('login_token')
                this.props.history.push(CONS.URL_LINK + '/login?auth=false')
            } else {
                console.log(error)
            }
        })
    }

    checkToken = (access_token) => {
        this.setState({ attr: { ...this.state.attr, access_token: access_token } }, this.loadData)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <MainLayout active="content" authorized="content" onCheckToken={this.checkToken}>
                <ContentEntryUI {...this} title="แก้ไขบทความ" />
            </MainLayout>
        )
    }
}

export default withRouter(ContentEdit)

